import { CHANGE_LANGUAGE } from '../types';
// eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return action.payload;
    default:
      return state;
  }
};